import { kgToMt } from "@/lib/format"
import type { Contract } from "@/types/domain"

export function allocatedToOTMt(contract: Contract): number {
  const kg = (contract.ExporterOTs ?? [])
    .filter((ot) => !ot.archived)
    .flatMap((ot) => ot.ExporterOTLots ?? [])
    .reduce((sum, link) => sum + (link.ExporterLots?.netKg ?? 0), 0)
  return kgToMt(kg)
}
